import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const IconInterviewRubric28Group: React.FC<SvgProps> = (props) => {
  return (
    <g {...(props.group ?? {})}>
      <rect width="28" height="28" rx="8" fill="#3A3AE8" />
      <g>
        <path
          d="M15.0938 18.1467C14.8657 17.8395 14.6796 17.5032 14.5405 17.1467H7.62049C7.53699 17.1433 7.455 17.1233 7.37936 17.0878C7.30372 17.0522 7.23596 17.0019 7.18005 16.9398C7.12414 16.8777 7.08123 16.805 7.05382 16.7261C7.02642 16.6471 7.01509 16.5635 7.02049 16.4801V8.90007C7.01509 8.81667 7.02642 8.73303 7.05382 8.65408C7.08123 8.57513 7.12414 8.50245 7.18005 8.44033C7.23596 8.37822 7.30372 8.32791 7.37936 8.29237C7.455 8.25683 7.53699 8.23678 7.62049 8.2334H13.8205C13.906 7.88287 14.0407 7.54621 14.2205 7.2334H7.62049C7.40403 7.23422 7.18991 7.27824 6.99067 7.36287C6.79144 7.4475 6.6111 7.57105 6.46023 7.72627C6.30935 7.88149 6.19097 8.06527 6.11203 8.26682C6.03309 8.46838 5.99517 8.68367 6.00049 8.90007V16.4934C5.99513 16.9243 6.16029 17.3399 6.45998 17.6496C6.75968 17.9593 7.16962 18.138 7.60049 18.1467H12.2138L11.8405 19.3801H10.8138C10.6812 19.3801 10.554 19.4327 10.4603 19.5265C10.3665 19.6203 10.3138 19.7475 10.3138 19.8801C10.3138 20.0127 10.3665 20.1398 10.4603 20.2336C10.554 20.3274 10.6812 20.3801 10.8138 20.3801H14.1472C14.4809 19.881 14.9008 19.4453 15.3872 19.0934L15.0938 18.1467Z"
          fill="white"
        />
        <path
          d="M22.0021 22.0001C21.7751 21.1752 21.2837 20.4477 20.6032 19.9292C19.9228 19.4107 19.0909 19.1299 18.2354 19.1299C17.3799 19.1299 16.5481 19.4107 15.8676 19.9292C15.1872 20.4477 14.6957 21.1752 14.4688 22.0001H22.0021Z"
          fill="white"
        />
        <path
          d="M13.2707 15.3333C13.1379 14.7556 12.813 14.24 12.3492 13.8708C11.8855 13.5016 11.3102 13.3005 10.7174 13.3005C10.1246 13.3005 9.54934 13.5016 9.08556 13.8708C8.62179 14.24 8.29694 14.7556 8.16406 15.3333H13.2707Z"
          fill="white"
        />
        <path
          d="M9.11719 11.1C9.11719 11.5243 9.28576 11.9313 9.58582 12.2314C9.88588 12.5314 10.2928 12.7 10.7172 12.7C11.1415 12.7 11.5485 12.5314 11.8486 12.2314C12.1486 11.9313 12.3172 11.5243 12.3172 11.1C12.3172 10.6757 12.1486 10.2687 11.8486 9.96863C11.5485 9.66857 11.1415 9.5 10.7172 9.5C10.2928 9.5 9.88588 9.66857 9.58582 9.96863C9.28576 10.2687 9.11719 10.6757 9.11719 11.1Z"
          fill="white"
        />
        <path
          d="M18.3618 6C16.3618 6 14.7151 7.39333 14.7151 9.10667C14.7226 9.63916 14.8847 10.158 15.1818 10.6C14.9245 11.1788 14.5755 11.7123 14.1484 12.18C14.6051 12.334 15.0878 12.3957 15.5685 12.3613C16.0492 12.327 16.5183 12.1974 16.9484 11.98C17.4025 12.1395 17.8805 12.2207 18.3618 12.22C20.3618 12.22 22.0084 10.8267 22.0084 9.10667C22.0084 7.38667 20.3751 6 18.3618 6Z"
          fill="white"
        />
        <path
          d="M18.2242 12.9133C17.6738 12.912 17.1354 13.0741 16.6772 13.3791C16.219 13.684 15.8616 14.1181 15.6504 14.6264C15.4392 15.1346 15.3835 15.6942 15.4906 16.234C15.5976 16.7739 15.8626 17.2699 16.2517 17.6591C16.6409 18.0483 17.1369 18.3132 17.6768 18.4202C18.2167 18.5273 18.7762 18.4717 19.2844 18.2604C19.7927 18.0492 20.2268 17.6918 20.5318 17.2337C20.8367 16.7755 20.9988 16.2371 20.9975 15.6867C20.9975 14.9511 20.7053 14.2457 20.1852 13.7256C19.6651 13.2055 18.9597 12.9133 18.2242 12.9133ZM18.2242 17.4667C17.7532 17.4649 17.3022 17.2766 16.9698 16.943C16.6374 16.6093 16.4508 16.1576 16.4508 15.6867C16.4467 15.3243 16.5512 14.9691 16.7508 14.6667C17.1417 15.1294 17.6287 15.5014 18.1778 15.757C18.7269 16.0125 19.3251 16.1455 19.9308 16.1467C19.8301 16.5232 19.6086 16.8563 19.3003 17.0947C18.992 17.3332 18.6139 17.4639 18.2242 17.4667Z"
          fill="white"
        />
      </g>
    </g>
  );
};

export const IconInterviewRubric28Svg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconInterviewRubric28Group {...props} />
    </svg>
  );
};
